import { Service, inject } from '@angular/core'
import {
  EntityPublicEvent,
  EventAvailability,
  GetEntityPublicEventsResponse,
  GetPublicEntityEventsQuery,
  JoinPublicEventBody,
  SuccessResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class PublicEntityEventApiService {
  private readonly api = inject(ApiService)

  getEntityPublicEvents(entityId: string, query: GetPublicEntityEventsQuery, init?: RequestInit) {
    const url = this.api.createURL(`entities/${entityId}/events`)
    url.search = this.api.toQueryParams(query)
    return this.api.fetchJson<GetEntityPublicEventsResponse>(url, { ...init })
  }

  /** One termín behind its link, public or unlisted; 404 when the public may not open it. */
  getEntityPublicEvent(entityId: string, eventId: string, init?: RequestInit) {
    return this.api.fetchJson<EntityPublicEvent>(`entities/${entityId}/events/${eventId}`, { ...init })
  }

  getPublicEventAvailability(entityId: string, eventId: string, init?: RequestInit) {
    return this.api.fetchJson<EventAvailability>(`entities/${entityId}/events/${eventId}/availability`, { ...init })
  }

  joinPublicEvent(entityId: string, eventId: string, body: JoinPublicEventBody, init?: RequestInit) {
    return this.api.fetchJson<SuccessResponse>(`entities/${entityId}/events/${eventId}/join`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
